<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:0em;">I would like to dedicate this collection of short stories to my son Nick for his invaluable support and advice.</p><br/>
<p style="text-indent:0em;">Also, a big thanks to Cath Humphris for giving me the inspiration to write these stories.</p><br/>
<p style="text-indent:0em;">For Clara and Ralph.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?05dd0f38